import React from 'react';
import Highlight from 'react-highlighter';
const HighlightText = ({ textToHighlight, highlightValue }) => (<Highlight search={highlightValue} ignoreDiacritics matchClass="search-list__highlight">
        {textToHighlight}
    </Highlight>);
export default HighlightText;
